import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'menusPipe'
})
export class FilterMenuPipe implements PipeTransform {
    transform(menus: any, term?: any): any {

        if (term === undefined) return menus;
        if (term === null) return menus;

        if (menus != null) {
            return menus.filter(function (menu) {
                if (menu.title_es != undefined)
                    if (menu.title_es.toString().toLowerCase().includes(term.toLowerCase()))
                        return menu;
                if (menu.subtitle_es != undefined)
                    if (menu.subtitle_es.toString().toLowerCase().includes(term.toLowerCase()))
                        return menu;
                if (menu.reference != undefined)
                    if (menu.reference.toString().toLowerCase().includes(term.toLowerCase()))
                        return menu;
                if (menu.price != undefined)
                    if (menu.price.toString().toLowerCase().includes(term.toLowerCase()))
                        return menu;
                if (menu.menu_cost != undefined)
                    if (menu.menu_cost.toString().toLowerCase().includes(term.toLowerCase()))
                        return menu;
            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/menu/filter.pipe.ts